<template>
<router-link :to="{ name: 'entity', params: { id: entity.entityId } }">{{entity.nameFormatted}}</router-link>
</template>

<script>
export default {
  name: "Entity",
  props: ["entity"]
};
</script>
